import { Typography } from '@mui/material'
import CustomTooltip from 'components/shared/CustomTooltip'

interface Props {
  label: string
  value: string
  tooltip: string
}

export default function AgentInfos(props: Props) {
  const { label, value, tooltip } = props
  return (
    <>
      <CustomTooltip title={tooltip}>
        <Typography
          fontSize={14}
          textAlign="center"
          textOverflow={tooltip ? 'ellipsis' : 'none'}
          noWrap
        >
          {value}
        </Typography>
      </CustomTooltip>

      <Typography fontSize={14} color={'gray'} textAlign="center">
        {label}
      </Typography>
    </>
  )
}
